export const getShipmentStatusClasses = (status?: string): string => {
  const s = status?.toLowerCase() || '';

  if (
    s.includes('undelivered') ||
    s.includes('exception') ||
    s.includes('failed') ||
    s.includes('cancel')
  ) {
    return 'bg-red-50 text-red-700 border-red-200';
  }
  if (s.includes('out for delivery')) {
    return 'bg-yellow-50 text-yellow-700 border-yellow-200';
  }
  if (s.includes('delivered')) {
    return 'bg-green-50 text-green-700 border-green-200';
  }
  if (s.includes('transit')) {
    return 'bg-purple-50 text-purple-700 border-purple-200';
  }
  if (
    s.includes('pickup') ||
    s.includes('picked') ||
    s.includes('ready') ||
    s.includes('manifest') ||
    s.includes('label')
  ) {
    return 'bg-blue-50 text-blue-500 border-blue-200';
  }
  if (s.includes('archive')) {
    return 'bg-amber-50 text-amber-700 border-amber-200';
  }
  // Default / Pending fallback
  return 'bg-gray-50 text-gray-700 border-gray-200';
};

export const formatStatusDisplay = (status?: string): string => {
  if (!status) return '';
  const trimmed = status.trim();
  if (trimmed.toLowerCase() === 'pickup scheduled') return 'Scheduled';

  if (
    trimmed.includes('_') ||
    (trimmed === trimmed.toUpperCase() && !trimmed.includes(' '))
  ) {
    return trimmed
      .split(/[_/\s]+/)
      .filter(Boolean)
      .map((word) => {
        const upper = word.toUpperCase();
        if (['RTO', 'COD', 'NDR'].includes(upper)) return upper;
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }

  return status;
};

export interface AppointmentEligibility {
  allowed: boolean;
  reason?: string;
}

export const checkAppointmentEligibility = (order?: {
  trackingStatus?: number;
  status?: string;
}): AppointmentEligibility => {
  if (!order) return { allowed: false, reason: 'Shipment details unavailable' };

  const statusStr = (order.status || '').toLowerCase().trim();
  const trackingStatus = order.trackingStatus;

  // 1. Pickup stage / Booked / Created / Cancelled
  if (
    trackingStatus === 1 ||
    trackingStatus === 4 ||
    trackingStatus === 7 ||
    trackingStatus === 8 ||
    trackingStatus === 11 ||
    trackingStatus === 20 ||
    statusStr.includes('pickup') ||
    statusStr.includes('booked') ||
    statusStr.includes('created') ||
    statusStr.includes('cancel')
  ) {
    return {
      allowed: false,
      reason: 'Appointments cannot be scheduled before shipment is picked up',
    };
  }

  // 2. Delivered (guard against "undelivered" / "out for delivery")
  if (
    trackingStatus === 5 ||
    (statusStr.includes('delivered') &&
      !statusStr.includes('undeliver') &&
      !statusStr.includes('out for delivery') &&
      !statusStr.includes('rto'))
  ) {
    return {
      allowed: false,
      reason: 'Appointments cannot be scheduled once shipment is Delivered',
    };
  }

  // 3. RTO / Returned
  if (
    trackingStatus === 6 ||
    trackingStatus === 12 ||
    trackingStatus === 13 ||
    trackingStatus === 14 ||
    trackingStatus === 15 ||
    statusStr.includes('rto') ||
    statusStr.includes('return')
  ) {
    return {
      allowed: false,
      reason: 'Appointments cannot be scheduled for RTO shipments',
    };
  }

  return { allowed: true };
};

